import StrumentiElenco from './StrumentiElenco';
export default StrumentiElenco;
